import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive( {
  selector: '[phoneData]'
} )
export class PhoneDirective {

  @Input( 'phoneData' ) input;
  index = true;

  constructor ( private el: ElementRef ) {
    this.el.nativeElement.maxLength = 13;

    if ( !this.el.nativeElement.value.length ) {
      this.el.nativeElement.value = '+380_________';
    }
  }

  @HostListener( 'input', ['$event'] )
  InputDate ( event ) {
    switch ( event.inputType ) {
      case 'insertText': {
        if ( event.target.value.match( /^\d$/ ) ) {
          event.target.value = '+380' + event.target.value;
        } else if ( event.target.value.match( /^\+380$/ ) !== null ) {
        }
        break;
      }
      case 'deleteContentBackward': {

        break;
      }
    }
  }

  @HostListener( 'paste', ['$event'] )
  InputPaste ( event ) {
    event.target.value = '';
  }

  @HostListener( 'focus', ['$event'] )
  FocusDate (  ) {
    if ( this.index && this.el.nativeElement.value.length <= 3 ) {
      this.el.nativeElement.value = '+380';
    }
    this.index = false;
    // console.log( event );
  }

  @HostListener( 'blur', ['$event'] )
  BlureDate () {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/phone.directive.ts